import { render, staticRenderFns } from "./wc-profit-centers.vue?vue&type=template&id=18ac942c&"
import script from "./wc-profit-centers.vue?vue&type=script&lang=js&"
export * from "./wc-profit-centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports